import moment from 'moment'
export const returnQueryByAxios = (form) => {
    let query = ""
    let index = 0;
    let flag = true;
    for (let i in form) {
        if (flag && form[i]) {
            query = `?${i}=${form[i]}`;
            flag = false;
        }
        else if (form[i])
            query += `&${i}=${form[i]}`;
        index++;
    }
    return query;
}

export const returnQueryByTools = (algId, algName, dependAlg, mxPoints, mxRelations, userid, username, x, y) => {
    let query = "?";
    let queryFlag = true;
    if (algId !== "") {
        query += "algId=" + algId;
        queryFlag = false;
    }

    if (queryFlag && algName !== "") {
        query += "algName=" + algName;
        queryFlag = false;
    }
    else if (algName !== "") {
        query += "&algName=" + algName;
    }

    if (queryFlag && dependAlg !== "") {
        query += "dependAlg=" + dependAlg;
        queryFlag = false;
    }
    else if (dependAlg !== "") {
        query += "&dependAlg=" + dependAlg;
    }

    if (queryFlag && mxPoints[0].algId !== "") {
        query += "mxPoints[0].algId=" + mxPoints[0].algId;
        queryFlag = false;
    }
    else if (mxPoints[0].algId !== "") {
        query += "&mxPoints[0].algId=" + mxPoints[0].algId;
    }

    if (queryFlag && mxPoints[0].x !== "") {
        query += "mxPoints[0].x=" + mxPoints[0].x;
        queryFlag = false;
    }
    else if (mxPoints[0].x !== "") {
        query += "&mxPoints[0].x=" + mxPoints[0].x;
    }

    if (queryFlag && mxPoints[0].y !== "") {
        query += "mxPoints[0].y=" + mxPoints[0].y;
        queryFlag = false;
    }
    else if (mxPoints[0].y !== "") {
        query += "&mxPoints[0].y=" + mxPoints[0].y;
    }

    if (queryFlag && mxRelations[0].algName !== "") {
        query += "mxRelations[0].algName=" + mxRelations[0].algName;
        queryFlag = false;
    }
    else if (mxRelations[0].algName !== "") {
        query += "&mxRelations[0].algName=" + mxRelations[0].algName;
    }

    if (queryFlag && mxRelations[0].dependAlg !== "") {
        query += "mxRelations[0].dependAlg=" + mxRelations[0].dependAlg;
        queryFlag = false;
    }
    else if (mxRelations[0].dependAlg !== "") {
        query += "&mxRelations[0].dependAlg=" + mxRelations[0].dependAlg;
    }

    if (queryFlag && userid !== "") {
        query += "userid=" + userid;
        queryFlag = false;
    }
    else if (userid !== "") {
        query += "&userid=" + userid;
    }

    if (queryFlag && username !== "") {
        query += "username=" + username;
        queryFlag = false;
    }
    else if (username !== "") {
        query += "&username=" + username;
    }

    if (queryFlag && x !== "") {
        query += "x=" + x;
        queryFlag = false;
    }
    else if (x !== "") {
        query += "&x=" + x;
    }

    if (queryFlag && y !== "") {
        query += "y=" + y;
        queryFlag = false;
    }
    else if (y !== "") {
        query += "&y=" + y;
    }

    return query;
}



/* 时间处理 */
export const monthToDay = (month) => {
    switch (month) {
        case 1:
            return 31;
        case 2:
            return 27;
        case 3:
            return 31;
        case 4:
            return 30;
        case 5:
            return 31;
        case 6:
            return 30;
        case 7:
            return 31;
        case 8:
            return 31;
        case 9:
            return 30;
        case 10:
            return 31;
        case 11:
            return 30;
        case 12:
            return 31;
        default:
            return 30;
    }
}
export const returnNewsTimeModeTime = (timeMode) => {
    switch (timeMode) {
        case "":
            return { fromTime: "", endTime: "" };
        case "oneWeek":
            return returnNowOneWeek();
        case "oneMonth":
            return returnNowOneMonth();
        case "threeMonth":
            return returnNowThreeMonth();
        default:
            return undefined;
    }
}

export const returnNowWeek = (num) => {
    let returnTime = {};
    returnTime.endTime = moment().format('YYYY-MM-DD HH:mm:ss');
    returnTime.fromTime = moment().subtract(num, 'weeks').format('YYYY-MM-DD HH:mm:ss');
    return returnTime;
}

export const returnNowOneWeek = () => {
    return returnNowWeek(1);
}

export const returnNowMonth = (num) => {
    let returnTime = {};
    returnTime.endTime = moment().format('YYYY-MM-DD HH:mm:ss');
    returnTime.fromTime = moment().subtract(num, 'months').format('YYYY-MM-DD HH:mm:ss');
    return returnTime;
}

export const returnNowOneMonth = () => {
    return returnNowMonth(1);
}
export const returnNowThreeMonth = () => {
    return returnNowMonth(3);
}


export const returnQueryBySearchNews = (keyWord, fromTime, endTime, source, limitCount, page) => {
    let query = "?";
    let queryFlag = true;
    if (keyWord !== "") {
        query += "keyWord=" + keyWord;
        queryFlag = false;
    }

    if (queryFlag && fromTime !== "") {
        query += "fromTime=" + fromTime;
        queryFlag = false;
    }
    else if (fromTime !== "") {
        query += "&fromTime=" + fromTime;
    }

    if (queryFlag && endTime !== "") {
        query += "endTime=" + endTime;
        queryFlag = false;
    }
    else if (endTime !== "") {
        query += "&endTime=" + endTime;
    }

    if (queryFlag && source !== "") {
        query += "source=" + source;
        queryFlag = false;
    }
    else if (source !== "") {
        query += "&source=" + source;
    }

    if (queryFlag) {
        query += "limitCount=" + limitCount + "&page=" + page;
    }
    else {
        query += "&limitCount=" + limitCount + "&page=" + page;
    }

    return query;
}

export const returnFileSizeText = (size) => {
    if ((size / 1000) < 1000) {
        return (size / 1000).toFixed(2) + " KB";
    }
    else if ((size / 1024 / 1000) < 1000) {
        return (size / 1024 / 1000).toFixed(2) + " MB";
    }
    else if ((size / 1024 / 1024 / 1000) < 1000) {
        return (size / 1024 / 1024 / 1000).toFixed(2) + " GB";
    }
    else {
        return (size / 1024 / 1024 / 1024 / 1000).toFixed(2) + " TB";
    }
}